import { ResizeObserverBoxOptions as r } from "./ResizeObserverBoxOptions.js";
import { calculateBoxSize as o } from "./algorithms/calculateBoxSize.js";
import { isSVG as s, isReplacedElement as n } from "./utils/element.js";
var l = function(e) {
  return !s(e) && !n(e) && getComputedStyle(e).display === "inline";
}, S = function() {
  function e(i, t) {
    this.target = i, this.observedBox = t || r.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var i = o(this.target, this.observedBox, !0);
    return l(this.target) && (this.lastReportedSize = i), this.lastReportedSize.inlineSize !== i.inlineSize || this.lastReportedSize.blockSize !== i.blockSize;
  }, e;
}();
export {
  S as ResizeObservation
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/ResizeObservation.js
// module id = 1347
// module chunks = 67